import React from "react";
import styles from "./index.module.css";

const CheckBox = ({ id, label, key, required=false, ...checkBoxArgs }) => {
    return (
        <div className={`${styles.formGroup} ${checkBoxArgs.checkBoxClassOverride}`} style={checkBoxArgs.formGroupStyleOverride} key={key}>
            <input
                {...checkBoxArgs}
                className={`${styles.input} ${checkBoxArgs.inputClassOverride}`}
                type="checkbox"
                required={required}
                style={checkBoxArgs.inputStyleOverride}
                // checked={false}
            />
            {label&&<label htmlFor={id}
                style={checkBoxArgs.labelStyleOverride}
            >{label} {required&&<span className="required">*</span>}</label>}
        </div>
    );
};

export default React.memo(CheckBox);
